import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonGroupModule, DxButtonModule, DxDataGridModule, DxToastModule, DxNumberBoxModule, DxTextBoxModule, DxDataGridComponent } from 'devextreme-angular';
import { MastrService } from 'src/app/services/mastr.service';
import { ActivatedRoute } from '@angular/router';
import { DeletePopupComponent } from 'src/app/components/delete-popup/delete-popup.component';
import { Route } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { LimitDigitsComponent } from 'src/app/components/limit-digits/limit-digits.component';
import { locale } from 'devextreme/localization';
import config from 'devextreme/core/config';
import { environment } from 'src/environments/environment';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { DocumentPillComponent, DocumentPillValue } from 'src/app/components/document-pill/document-pill.component';
//import deMessages from "devextreme/localization/messages/de.json";
//import { locale, loadMessages } from "devextreme/localization";

//import config from 'devextreme/core/config';





@Component({
    selector: 'app-project-info-mastr',
    imports: [CommonModule, DxDataGridModule, DxButtonModule, DeletePopupComponent, DxToastModule, DxButtonGroupModule, DxNumberBoxModule, DxTextBoxModule, LimitDigitsComponent, GpdButtonComponent, DocumentPillComponent],
    templateUrl: './project-info-mastr.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-info-mastr.component.css']
})
export class ProjectInfoMastrComponent implements OnInit {


  type: any = '';
  message: any = '';
  toastTwoVisible: boolean = false;

  @ViewChild('mastrGrid') mastrGrid;

  projectId: Number = 0;

  mastr = new Array();

  newId: number = 0;

  editMode: boolean = false;

  rules: any = { X: /[02-9]/ };

  deleteMessage: string;
  itemToDelete: any;
  deletePopupVisible: boolean = false;

  toastVisible: boolean = false;
  mastrStatus = 1;

  confirmText: any = $localize`:@@confirmCaps:CONFIRM`;
  cancelText: any = $localize`:@@cancelCaps:CANCEL`;

  maxNumberRemuneration: any = 99999

  locale = "de-DE";

  searchTerm: string = AppGlobals.searchPanelText;
  contentLoadedVisible: boolean = true;

  currentEditingItem: any = null;

    @ViewChild(DxDataGridComponent, { static: false }) dataGridSearch: DxDataGridComponent;


  constructor(private mastrService: MastrService, private activatedRoute: ActivatedRoute, private appGlobals: AppGlobals, private activityLog: ActivityLogService) {

    //  config({ defaultCurrency: 'EUR' });
    // loadMessages(deMessages);
    // locale(navigator.language);
    config({
      thousandsSeparator: ".",
      decimalSeparator: ","
    });

    locale(this.locale);
  }

  ngOnInit(): void {
    if (environment.isTestEnvironment === true) {
      this.appGlobals.SetGlobalMenuIndex(2);
    } else {
      this.appGlobals.SetGlobalMenuIndex(2);
    }
    this.projectId = Number(this.activatedRoute.snapshot.params.id);
    this.activityLog.logView({ Section: ActivitySection.PROJECT_MASTR, ProjectId: Number(this.projectId) });
    this.getPageData();
  }

  // Konformitätsbestätigung: the form choice is staged until CONFIRM (applied in saveChanges), dropped on CANCEL.
  // Pill values are cached fields - a method returning a fresh object would reset the bound widget every CD.
  staged: { file: File | null; removed: boolean } = { file: null, removed: false };
  formPill: DocumentPillValue | null = null;
  // Keyed by row object, not id: after a reload the grid still renders the old row objects for one CD pass and would
  // re-cache their (document-less) pill under the id, which the new row objects would then inherit.
  private gridPills = new WeakMap<object, DocumentPillValue | null>();

  private toPill(uuid: string, name: string): DocumentPillValue {
    return { id: uuid, documentName: name, type: 'property-file' };
  }

  gridPill(row: any): DocumentPillValue | null {
    if (!this.gridPills.has(row)) {
      this.gridPills.set(row, row.conformityDocumentUuid ? this.toPill(row.conformityDocumentUuid, row.conformityDocumentName) : null);
    }
    return this.gridPills.get(row);
  }

  private resetStaged() {
    this.staged = { file: null, removed: false };
    const row = this.currentEditingItem;
    this.formPill = row?.conformityDocumentUuid ? this.toPill(row.conformityDocumentUuid, row.conformityDocumentName) : null;
  }

  stageUpload(file: File, item: any) {
    this.staged = { file, removed: false };
    this.formPill = null; // a staged file has no SharePoint id yet; the form shows its name instead
    // Marks the form dirty so CONFIRM saves; the row has no such property, so the value must never be null/undefined
    // (undefined -> null is not a change). Stripped again before saveMastrData.
    item.setValue(`upload:${file.name}`);
  }

  stageRemove(item: any) {
    this.staged = { file: null, removed: !!this.currentEditingItem?.conformityDocumentUuid };
    this.formPill = null;
    item.setValue('remove');
  }

  onFormFilePicked(e: Event, item: any) {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (file) this.stageUpload(file, item);
  }

  onGridFilePicked(e: Event, row: any) {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0];
    input.value = '';
    if (file) this.uploadConformity(row.id, file).then(() => this.getPageData());
  }

  onEditCanceled() {
    this.resetStaged();
  }

  onInitNewRow() {
    this.currentEditingItem = null;
    this.resetStaged();
  }

  // True while an upload or delete request is in flight; disables the upload/remove buttons.
  busy = false;

  get canEdit(): boolean {
    return AppGlobals.UserPermissions.canEdit === true;
  }

  private async uploadConformity(mastrId: number, file: File) {
    this.busy = true;
    const formData = new FormData();
    formData.append('ProjectId', String(this.projectId));
    formData.append('MastrId', String(mastrId));
    formData.append('Filename', file.name);
    formData.append('FileType', file.type);
    formData.append('FileBytes', file);
    try {
      const result = await this.mastrService.uploadConformityDocument(formData);
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(error);
    } finally {
      this.busy = false;
    }
  }

  private async deleteConformity(mastrId: number) {
    this.busy = true;
    try {
      const result = await this.mastrService.deleteConformityDocument({ ProjectId: Number(this.projectId), MastrId: mastrId });
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(error);
    } finally {
      this.busy = false;
    }
  }

  // Returns true when it already reloaded the list and changed nothing afterwards, so the caller can skip its own reload.
  private async applyStaged(staged: { file: File | null; removed: boolean }, editedId: number, idsBefore: Set<number>): Promise<boolean> {
    const { file, removed } = staged;
    if (!file && !removed) return false;
    let id = editedId;
    if (!(id > 0)) {
      // New row: its real id only exists after the reload (SaveMastrData returns none).
      await this.getPageData();
      const added = this.mastr.filter(r => !idsBefore.has(r.id));
      if (added.length !== 1) {
        AppGlobals.ShowErrorMessage($localize`:@@conformityDocumentNotAssigned:The registration confirmation after commissioning could not be assigned – please upload it again in the edit dialog.`);
        return true;
      }
      id = added[0].id;
    }
    if (file) await this.uploadConformity(id, file);
    else await this.deleteConformity(id);
    return false;
  }

  getPageData() {
    let payload = {
      gridConnectionId: 1,
      projectId: Number(this.projectId),
      MastrDataItems: []
    }

    return this.mastrService.getMastrData(payload).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.mastr = result.mastrDataItems;
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  addRow(e) {
    this.currentEditingItem = null;
    this.mastrGrid.instance.addRow();
  }

  async saveChanges(e) {
    // Taken up front: toggleEditMode below cancels the grid edit (onEditCanceled), which resets the staged state.
    const staged = this.staged;
    const editedId = this.currentEditingItem?.id;
    const idsBefore = new Set<number>(this.mastr.map(r => r.id));
    let payload = {
      gridConnectionId: 1,
      projectId: Number(this.projectId),
      MastrDataItems: this.mastr.map(({ conformityDocument, ...row }) => row) // drop the form-dirty marker
    }

    await this.mastrService.saveMastrData(payload).then(async (result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.toastVisible = true;
        this.toggleEditMode(false);
        this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
        const reloaded = await this.applyStaged(staged, editedId, idsBefore);
        this.resetStaged();
        if (!reloaded) await this.getPageData();
      }

    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if (this.type = 'success') {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastTwoVisible = true;
  }

  doSearch(e: any): void {
        this.contentLoadedVisible = false;
        this.searchTerm = e.value;
        if (this.searchTerm.length < 2) {
            if (this.dataGridSearch) {
                this.dataGridSearch.instance.searchByText('');
                this.appGlobals.setSearchPanelText('');
                this.contentLoadedVisible = true;
            }
            return;
        }
        if (this.dataGridSearch) {
            this.dataGridSearch.instance.searchByText(this.searchTerm);
            this.appGlobals.setSearchPanelText(this.searchTerm);
            this.contentLoadedVisible = true;
        }
    }

  getNewId() {
    this.newId -= 1;
    return this.newId;
  }

  initNewRow(e) {
    if (e.data.id == null || e.data.id == undefined) {
      e.data.id = this.getNewId();
    }
  }

  toggleEditMode(arg) {
    this.editMode = arg;
    this.mastrGrid.instance.cancelEditData();
  }

  onEditingStart(e: any) {
    this.currentEditingItem = e.data ?? null;
    this.resetStaged();
  }

  onFormDeleteClick() {
    this.mastrGrid.instance.cancelEditData();
    this.initDeleteRow(this.currentEditingItem);
  }

  editRow(e, rowIndex) {
    this.mastrGrid.instance.editRow(rowIndex);
  }

  initDeleteRow(itemToDelete) {
    this.deletePopupVisible = true;
    this.itemToDelete = itemToDelete;
    this.deleteMessage = $localize`Are you sure you ant to delete this item?`;
  }

  deleteRow() {

    let index = this.mastr.findIndex(item => item.id == this.itemToDelete.id);
    this.mastr.splice(index, 1);

    let payload = {
      gridConnectionId: 1,
      projectId: Number(this.projectId),
      MastrDataItems: [this.itemToDelete]
    }

    this.mastrService.deleteMastrData(payload).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
        this.itemToDelete = null;
        this.saveToast({ type: true, feedback: $localize`:@@deleted:Deleted` });
      }

    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }

  onAbort(e) {
    this.itemToDelete = null;
    this.deletePopupVisible = false;
  }

  onConfirm(e) {
    this.deleteRow();
    this.deletePopupVisible = false;
  }

  setMastrTaskStatus(e) {
    this.mastrStatus = e;

    this.mastrService.setMastrTaskStatus({ ProjectId: this.projectId, StatusId: this.mastrStatus }).then((result) => {
      if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
      else {
      }
    },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      });
  }


  handleCustomNumberKeyUp(e: any, item: any): void {
    if (e.event.currentTarget.value == null) return;
    let finalValue = '';
    let currentValue = e.event.currentTarget.value;
    let dotCount = 0;
    for (let i = 0; i < currentValue.length; i++) {
      if (currentValue[i] == ',' || currentValue[i] == '.' || isNaN(currentValue[i]) == false) {
        if (currentValue[i] == ',' || currentValue[i] == '.') dotCount++;
        if (dotCount > 1) continue;
        finalValue += currentValue[i];
      }
    }
    e.event.currentTarget.value = finalValue;
    item.setValue(finalValue);
  }

  handleCustomNumberChange(e: any, item: any): void {
    let finalVlaue = item.value.replace(',', '.');
    item.setValue(finalVlaue);
  }

  reFormatNumber(event: any): void {
    let cellValue = event.component._parsedValue;
    event.component._parsedValue = new Intl.NumberFormat('de-DE').format(cellValue);
  }

  returnToParesedValue(value: string): any {
    const parts = value.split(',');

    // Check if there are more than one comma
    if (parts.length > 2) {
      return parts.length[0] + parts.length[1];
    }

    const integerPart = parts[0].replace(/\./g, '');
    const decimalPart = parts[1] || '';
    return decimalPart ? `${integerPart}.${decimalPart}` : integerPart;
  }

  async remunerationRateDigitsLimited(e: any, dataSource) {
    let parsedNumber = parseFloat(this.returnToParesedValue(e));
    dataSource.data.remunerationRate = parsedNumber;
    for (let i = 0; i < this.mastr.length; i++) {
      if (dataSource.data.id === this.mastr[i].id) {
        this.mastr[i].remunerationRate = parsedNumber;
      }
    }
  }

  async powerOutputDigitsLimited(e: any, dataSource) {
    let value = this.returnToParesedValue(e);
    let parsedNumber = value;
    dataSource.data.powerOutputOfUnit = parsedNumber;
    for (let i = 0; i < this.mastr.length; i++) {
      if (dataSource.data.id === this.mastr[i].id) {
        this.mastr[i].powerOutputOfUnit = parsedNumber;
      }
    }
  }

  async maxPowerOutputOfUnitDigitsLimited(e: any, dataSource) {
    let value = this.returnToParesedValue(e);
    let parsedNumber = value;
    dataSource.data.maxPowerOutputOfUnit = parsedNumber;
    for (let i = 0; i < this.mastr.length; i++) {
      if (dataSource.data.id === this.mastr[i].id) {
        this.mastr[i].maxPowerOutputOfUnit = parsedNumber;
      }
    }
  }


  parseGermanNumber(value: string): number {
    const withoutThousandSeparators = value.replace(/\./g, '');
    const withDecimalDot = withoutThousandSeparators.replace(',', '.');
    return parseFloat(withDecimalDot);
  }

  formatNumberConvetionsFive(value: number): string {
    if (isNaN(value)) {
      return '';
    }
    return value.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 5, });
  }



  formatNumberConvetionsThree(value: number): string {
    if (isNaN(value)) {
      return '';
    }
    return value.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 3, });
  }



  checkDigits(e, maxDigits) {
  }

  print(e) {
    return true;
  }
}
